import { ChangedHighlightType } from 'component/Search/Form/types';

import { atom } from 'jotai';

export const changedTravelDateAtom = atom(false);
export const changedTravellerOrRoomAtom = atom(false);
export const changedDaysAtom = atom(false);
export const changedOpenTypeAtom = atom(ChangedHighlightType.None);
export const changedTooltipAtom = atom(false);
